import { z } from 'zod/v4'
import { WithHistory, WithId } from '../base-models'

export const PbsAdQualityConfigSchema = z.object({
  blockedCategories: z.array(z.string()).optional(),
  blockedAdvertiserDomains: z.array(z.string()).optional(),
  collectBidResponseMetricRate: z.number().optional(),
})

export type PbsAdQualityConfig = z.infer<typeof PbsAdQualityConfigSchema>

export interface PbsAdQualityConfigEntity extends WithId, WithHistory {
  adQualityConfig: PbsAdQualityConfig
}

// IAB Content Taxonomies v1.0
export const IAB_CATEGORY_MAP: Record<string, string> = {
  IAB1: 'IAB1 - Arts & Entertainment',
  'IAB1-1': 'IAB1-1 - Books & Literature',
  'IAB1-2': 'IAB1-2 - Celebrity Fan/Gossip',
  'IAB1-3': 'IAB1-3 - Fine Art',
  'IAB1-4': 'IAB1-4 - Humor',
  'IAB1-5': 'IAB1-5 - Movies',
  'IAB1-6': 'IAB1-6 - Music',
  'IAB1-7': 'IAB1-7 - Television',

  IAB2: 'IAB2 - Automotive',
  'IAB2-1': 'IAB2-1 - Auto Parts',
  'IAB2-2': 'IAB2-2 - Auto Repair',
  'IAB2-3': 'IAB2-3 - Buying/Selling Cars',
  'IAB2-4': 'IAB2-4 - Car Culture',
  'IAB2-5': 'IAB2-5 - Certified Pre-Owned',
  'IAB2-6': 'IAB2-6 - Convertible',
  'IAB2-7': 'IAB2-7 - Coupe',
  'IAB2-8': 'IAB2-8 - Crossover',
  'IAB2-9': 'IAB2-9 - Diesel',
  'IAB2-10': 'IAB2-10 - Electric Vehicle',
  'IAB2-11': 'IAB2-11 - Hatchback',
  'IAB2-12': 'IAB2-12 - Hybrid',
  'IAB2-13': 'IAB2-13 - Luxury',
  'IAB2-14': 'IAB2-14 - MiniVan',
  'IAB2-15': 'IAB2-15 - Motorcycles',
  'IAB2-16': 'IAB2-16 - Off-Road Vehicles',
  'IAB2-17': 'IAB2-17 - Performance Vehicles',
  'IAB2-18': 'IAB2-18 - Pickup',
  'IAB2-19': 'IAB2-19 - Road-Side Assistance',
  'IAB2-20': 'IAB2-20 - Sedan',
  'IAB2-21': 'IAB2-21 - Trucks & Accessories',
  'IAB2-22': 'IAB2-22 - Vintage Cars',
  'IAB2-23': 'IAB2-23 - Wagon',

  IAB3: 'IAB3 - Business',
  'IAB3-1': 'IAB3-1 - Advertising',
  'IAB3-2': 'IAB3-2 - Agriculture',
  'IAB3-3': 'IAB3-3 - Biotech/Biomedical',
  'IAB3-4': 'IAB3-4 - Business Software',
  'IAB3-5': 'IAB3-5 - Construction',
  'IAB3-6': 'IAB3-6 - Forestry',
  'IAB3-7': 'IAB3-7 - Government',
  'IAB3-8': 'IAB3-8 - Green Solutions',
  'IAB3-9': 'IAB3-9 - Human Resources',
  'IAB3-10': 'IAB3-10 - Logistics',
  'IAB3-11': 'IAB3-11 - Marketing',
  'IAB3-12': 'IAB3-12 - Metals',

  IAB4: 'IAB4 - Careers',
  'IAB4-1': 'IAB4-1 - Career Planning',
  'IAB4-2': 'IAB4-2 - College',
  'IAB4-3': 'IAB4-3 - Financial Aid',
  'IAB4-4': 'IAB4-4 - Job Fairs',
  'IAB4-5': 'IAB4-5 - Job Search',
  'IAB4-6': 'IAB4-6 - Resume Writing/Advice',
  'IAB4-7': 'IAB4-7 - Nursing',
  'IAB4-8': 'IAB4-8 - Scholarships',
  'IAB4-9': 'IAB4-9 - Telecommuting',
  'IAB4-10': 'IAB4-10 - U.S. Military',
  'IAB4-11': 'IAB4-11 - Career Advice',

  IAB5: 'IAB5 - Education',
  'IAB5-1': 'IAB5-1 - 7-12 Education',
  'IAB5-2': 'IAB5-2 - Adult Education',
  'IAB5-3': 'IAB5-3 - Art History',
  'IAB5-4': 'IAB5-4 - Colledge Administration',
  'IAB5-5': 'IAB5-5 - College Life',
  'IAB5-6': 'IAB5-6 - Distance Learning',
  'IAB5-7': 'IAB5-7 - English as a 2nd Language',
  'IAB5-8': 'IAB5-8 - Language Learning',
  'IAB5-9': 'IAB5-9 - Graduate School',
  'IAB5-10': 'IAB5-10 - Homeschooling',
  'IAB5-11': 'IAB5-11 - Homework/Study Tips',
  'IAB5-12': 'IAB5-12 - K-6 Educators',
  'IAB5-13': 'IAB5-13 - Private School',
  'IAB5-14': 'IAB5-14 - Special Education',
  'IAB5-15': 'IAB5-15 - Studying Business',

  IAB6: 'IAB6 - Family & Parenting',
  'IAB6-1': 'IAB6-1 - Adoption',
  'IAB6-2': 'IAB6-2 - Babies & Toddlers',
  'IAB6-3': 'IAB6-3 - Daycare/Pre School',
  'IAB6-4': 'IAB6-4 - Family Internet',
  'IAB6-5': 'IAB6-5 - Parenting - K-6 Kids',
  'IAB6-6': 'IAB6-6 - Parenting teens',
  'IAB6-7': 'IAB6-7 - Pregnancy',
  'IAB6-8': 'IAB6-8 - Special Needs Kids',
  'IAB6-9': 'IAB6-9 - Eldercare',

  IAB7: 'IAB7 - Health & Fitness',
  'IAB7-1': 'IAB7-1 - Exercise',
  'IAB7-2': 'IAB7-2 - A.D.D.',
  'IAB7-3': 'IAB7-3 - AIDS/HIV',
  'IAB7-4': 'IAB7-4 - Allergies',
  'IAB7-5': 'IAB7-5 - Alternative Medicine',
  'IAB7-6': 'IAB7-6 - Arthritis',
  'IAB7-7': 'IAB7-7 - Asthma',
  'IAB7-8': 'IAB7-8 - Autism/PDD',
  'IAB7-9': 'IAB7-9 - Bipolar Disorder',
  'IAB7-10': 'IAB7-10 - Brain Tumor',
  'IAB7-11': 'IAB7-11 - Cancer',
  'IAB7-12': 'IAB7-12 - Cholesterol',
  'IAB7-13': 'IAB7-13 - Chronic Fatigue Syndrome',
  'IAB7-14': 'IAB7-14 - Chronic Pain',
  'IAB7-15': 'IAB7-15 - Cold & Flu',
  'IAB7-16': 'IAB7-16 - Deafness',
  'IAB7-17': 'IAB7-17 - Dental Care',
  'IAB7-18': 'IAB7-18 - Depression',
  'IAB7-19': 'IAB7-19 - Dermatology',
  'IAB7-20': 'IAB7-20 - Diabetes',
  'IAB7-21': 'IAB7-21 - Epilepsy',
  'IAB7-22': 'IAB7-22 - GERD/Acid Reflux',
  'IAB7-23': 'IAB7-23 - Headaches/Migraines',
  'IAB7-24': 'IAB7-24 - Heart Disease',
  'IAB7-25': 'IAB7-25 - Herbs for Health',
  'IAB7-26': 'IAB7-26 - Holistic Healing',
  'IAB7-27': "IAB7-27 - IBS/Crohn's Disease",
  'IAB7-28': 'IAB7-28 - Incest/Abuse Support',
  'IAB7-29': 'IAB7-29 - Incontinence',
  'IAB7-30': 'IAB7-30 - Infertility',
  'IAB7-31': "IAB7-31 - Men's Health",
  'IAB7-32': 'IAB7-32 - Nutrition',
  'IAB7-33': 'IAB7-33 - Orthopedics',
  'IAB7-34': 'IAB7-34 - Panic/Anxiety Disorders',
  'IAB7-35': 'IAB7-35 - Pediatrics',
  'IAB7-36': 'IAB7-36 - Physical Therapy',
  'IAB7-37': 'IAB7-37 - Psychology/Psychiatry',
  'IAB7-38': 'IAB7-38 - Senor Health',
  'IAB7-39': 'IAB7-39 - Sexuality',
  'IAB7-40': 'IAB7-40 - Sleep Disorders',
  'IAB7-41': 'IAB7-41 - Smoking Cessation',
  'IAB7-42': 'IAB7-42 - Substance Abuse',
  'IAB7-43': 'IAB7-43 - Thyroid Disease',
  'IAB7-44': 'IAB7-44 - Weight Loss',
  'IAB7-45': "IAB7-45 - Women's Health",

  IAB8: 'IAB8 - Food & Drink',
  'IAB8-1': 'IAB8-1 - American Cuisine',
  'IAB8-2': 'IAB8-2 - Barbecues & Grilling',
  'IAB8-3': 'IAB8-3 - Cajun/Creole',
  'IAB8-4': 'IAB8-4 - Chinese Cuisine',
  'IAB8-5': 'IAB8-5 - Cocktails/Beer',
  'IAB8-6': 'IAB8-6 - Coffee/Tea',
  'IAB8-7': 'IAB8-7 - Cuisine-Specific',
  'IAB8-8': 'IAB8-8 - Desserts & Baking',
  'IAB8-9': 'IAB8-9 - Dining Out',
  'IAB8-10': 'IAB8-10 - Food Allergies',
  'IAB8-11': 'IAB8-11 - French Cuisine',
  'IAB8-12': 'IAB8-12 - Health/Lowfat Cooking',
  'IAB8-13': 'IAB8-13 - Italian Cuisine',
  'IAB8-14': 'IAB8-14 - Japanese Cuisine',
  'IAB8-15': 'IAB8-15 - Mexican Cuisine',
  'IAB8-16': 'IAB8-16 - Vegan',
  'IAB8-17': 'IAB8-17 - Vegetarian',
  'IAB8-18': 'IAB8-18 - Wine',

  IAB9: 'IAB9 - Hobbies & Interests',
  'IAB9-1': 'IAB9-1 - Art/Technology',
  'IAB9-2': 'IAB9-2 - Arts & Crafts',
  'IAB9-3': 'IAB9-3 - Beadwork',
  'IAB9-4': 'IAB9-4 - Birdwatching',
  'IAB9-5': 'IAB9-5 - Board Games/Puzzles',
  'IAB9-6': 'IAB9-6 - Candle & Soap Making',
  'IAB9-7': 'IAB9-7 - Card Games',
  'IAB9-8': 'IAB9-8 - Chess',
  'IAB9-9': 'IAB9-9 - Cigars',
  'IAB9-10': 'IAB9-10 - Collecting',
  'IAB9-11': 'IAB9-11 - Comic Books',
  'IAB9-12': 'IAB9-12 - Drawing/Sketching',
  'IAB9-13': 'IAB9-13 - Freelance Writing',
  'IAB9-14': 'IAB9-14 - Genealogy',
  'IAB9-15': 'IAB9-15 - Getting Published',
  'IAB9-16': 'IAB9-16 - Guitar',
  'IAB9-17': 'IAB9-17 - Home Recording',
  'IAB9-18': 'IAB9-18 - Investors & Patents',
  'IAB9-19': 'IAB9-19 - Jewelry Making',
  'IAB9-20': 'IAB9-20 - Magic & Illusion',
  'IAB9-21': 'IAB9-21 - Needlework',
  'IAB9-22': 'IAB9-22 - Painting',
  'IAB9-23': 'IAB9-23 - Photography',
  'IAB9-24': 'IAB9-24 - Radio',
  'IAB9-25': 'IAB9-25 - Roleplaying Games',
  'IAB9-26': 'IAB9-26 - Sci-Fi & Fantasy',
  'IAB9-27': 'IAB9-27 - Scrapbooking',
  'IAB9-28': 'IAB9-28 - Screenwriting',
  'IAB9-29': 'IAB9-29 - Stamps & Coins',
  'IAB9-30': 'IAB9-30 - Video & Computer Games',
  'IAB9-31': 'IAB9-31 - Woodworking',

  IAB10: 'IAB10 - Home & Garden',
  'IAB10-1': 'IAB10-1 - Appliances',
  'IAB10-2': 'IAB10-2 - Entertaining',
  'IAB10-3': 'IAB10-3 - Environmental Safety',
  'IAB10-4': 'IAB10-4 - Gardening',
  'IAB10-5': 'IAB10-5 - Home Repair',
  'IAB10-6': 'IAB10-6 - Home Theater',
  'IAB10-7': 'IAB10-7 - Interior Decorating',
  'IAB10-8': 'IAB10-8 - Landscaping',
  'IAB10-9': 'IAB10-9 - Remodeling & Construction',

  IAB11: "IAB11 - Law, Gov't & Politics",
  'IAB11-1': 'IAB11-1 - Immigration',
  'IAB11-2': 'IAB11-2 - Legal Issues',
  'IAB11-3': 'IAB11-3 - U.S. Government Resources',
  'IAB11-4': 'IAB11-4 - Politics',
  'IAB11-5': 'IAB11-5 - Commentary',

  IAB12: 'IAB12 - News',
  'IAB12-1': 'IAB12-1 - International News',
  'IAB12-2': 'IAB12-2 - National News',
  'IAB12-3': 'IAB12-3 - Local News',

  IAB13: 'IAB13 - Personal Finance',
  'IAB13-1': 'IAB13-1 - Beginning Investing',
  'IAB13-2': 'IAB13-2 - Credit/Debt & Loans',
  'IAB13-3': 'IAB13-3 - Financial News',
  'IAB13-4': 'IAB13-4 - Financial Planning',
  'IAB13-5': 'IAB13-5 - Hedge Fund',
  'IAB13-6': 'IAB13-6 - Insurance',
  'IAB13-7': 'IAB13-7 - Investing',
  'IAB13-8': 'IAB13-8 - Mutual Funds',
  'IAB13-9': 'IAB13-9 - Options',
  'IAB13-10': 'IAB13-10 - Retirement Planning',
  'IAB13-11': 'IAB13-11 - Stocks',
  'IAB13-12': 'IAB13-12 - Tax Planning',

  IAB14: 'IAB14 - Society',
  'IAB14-1': 'IAB14-1 - Dating',
  'IAB14-2': 'IAB14-2 - Divorce Support',
  'IAB14-3': 'IAB14-3 - Gay Life',
  'IAB14-4': 'IAB14-4 - Marriage',
  'IAB14-5': 'IAB14-5 - Senior Living',
  'IAB14-6': 'IAB14-6 - Teens',
  'IAB14-7': 'IAB14-7 - Weddings',
  'IAB14-8': 'IAB14-8 - Ethnic Specific',

  IAB15: 'IAB15 - Science',
  'IAB15-1': 'IAB15-1 - Astrology',
  'IAB15-2': 'IAB15-2 - Biology',
  'IAB15-3': 'IAB15-3 - Chemistry',
  'IAB15-4': 'IAB15-4 - Geology',
  'IAB15-5': 'IAB15-5 - Paranormal Phenomena',
  'IAB15-6': 'IAB15-6 - Physics',
  'IAB15-7': 'IAB15-7 - Space/Astronomy',
  'IAB15-8': 'IAB15-8 - Geography',
  'IAB15-9': 'IAB15-9 - Botany',
  'IAB15-10': 'IAB15-10 - Weather',

  IAB16: 'IAB16 - Pets',
  'IAB16-1': 'IAB16-1 - Aquariums',
  'IAB16-2': 'IAB16-2 - Birds',
  'IAB16-3': 'IAB16-3 - Cats',
  'IAB16-4': 'IAB16-4 - Dogs',
  'IAB16-5': 'IAB16-5 - Large Animals',
  'IAB16-6': 'IAB16-6 - Reptiles',
  'IAB16-7': 'IAB16-7 - Veterinary Medicine',

  IAB17: 'IAB17 - Sports',
  'IAB17-1': 'IAB17-1 - Auto Racing',
  'IAB17-2': 'IAB17-2 - Baseball',
  'IAB17-3': 'IAB17-3 - Bicycling',
  'IAB17-4': 'IAB17-4 - Bodybuilding',
  'IAB17-5': 'IAB17-5 - Boxing',
  'IAB17-6': 'IAB17-6 - Canoeing/Kayaking',
  'IAB17-7': 'IAB17-7 - Cheerleading',
  'IAB17-8': 'IAB17-8 - Climbing',
  'IAB17-9': 'IAB17-9 - Cricket',
  'IAB17-10': 'IAB17-10 - Figure Skating',
  'IAB17-11': 'IAB17-11 - Fly Fishing',
  'IAB17-12': 'IAB17-12 - Football',
  'IAB17-13': 'IAB17-13 - Freshwater Fishing',
  'IAB17-14': 'IAB17-14 - Game & Fish',
  'IAB17-15': 'IAB17-15 - Golf',
  'IAB17-16': 'IAB17-16 - Horse Racing',
  'IAB17-17': 'IAB17-17 - Horses',
  'IAB17-18': 'IAB17-18 - Hunting/Shooting',
  'IAB17-19': 'IAB17-19 - Inline Skating',
  'IAB17-20': 'IAB17-20 - Martial Arts',
  'IAB17-21': 'IAB17-21 - Mountain Biking',
  'IAB17-22': 'IAB17-22 - NASCAR Racing',
  'IAB17-23': 'IAB17-23 - Olympics',
  'IAB17-24': 'IAB17-24 - Paintball',
  'IAB17-25': 'IAB17-25 - Power & Motorcycles',
  'IAB17-26': 'IAB17-26 - Pro Basketball',
  'IAB17-27': 'IAB17-27 - Pro Ice Hockey',
  'IAB17-28': 'IAB17-28 - Rodeo',
  'IAB17-29': 'IAB17-29 - Rugby',
  'IAB17-30': 'IAB17-30 - Running/Jogging',
  'IAB17-31': 'IAB17-31 - Sailing',
  'IAB17-32': 'IAB17-32 - Saltwater Fishing',
  'IAB17-33': 'IAB17-33 - Scuba Diving',
  'IAB17-34': 'IAB17-34 - Skateboarding',
  'IAB17-35': 'IAB17-35 - Skiing',
  'IAB17-36': 'IAB17-36 - Snowboarding',
  'IAB17-37': 'IAB17-37 - Surfing/Bodyboarding',
  'IAB17-38': 'IAB17-38 - Swimming',
  'IAB17-39': 'IAB17-39 - Table Tennis/Ping-Pong',
  'IAB17-40': 'IAB17-40 - Tennis',
  'IAB17-41': 'IAB17-41 - Volleyball',
  'IAB17-42': 'IAB17-42 - Walking',
  'IAB17-43': 'IAB17-43 - Waterski/Wakeboard',
  'IAB17-44': 'IAB17-44 - World Soccer',

  IAB18: 'IAB18 - Style & Fashion',
  'IAB18-1': 'IAB18-1 - Beauty',
  'IAB18-2': 'IAB18-2 - Body Art',
  'IAB18-3': 'IAB18-3 - Fashion',
  'IAB18-4': 'IAB18-4 - Jewelry',
  'IAB18-5': 'IAB18-5 - Clothing',
  'IAB18-6': 'IAB18-6 - Accessories',

  IAB19: 'IAB19 - Technology & Computing',
  'IAB19-1': 'IAB19-1 - 3-D Graphics',
  'IAB19-2': 'IAB19-2 - Animation',
  'IAB19-3': 'IAB19-3 - Antivirus Software',
  'IAB19-4': 'IAB19-4 - C/C++',
  'IAB19-5': 'IAB19-5 - Cameras & Camcorders',
  'IAB19-6': 'IAB19-6 - Cell Phones',
  'IAB19-7': 'IAB19-7 - Computer Certification',
  'IAB19-8': 'IAB19-8 - Computer Networking',
  'IAB19-9': 'IAB19-9 - Computer Peripherals',
  'IAB19-10': 'IAB19-10 - Computer Reviews',
  'IAB19-11': 'IAB19-11 - Data Centers',
  'IAB19-12': 'IAB19-12 - Databases',
  'IAB19-13': 'IAB19-13 - Desktop Publishing',
  'IAB19-14': 'IAB19-14 - Desktop Video',
  'IAB19-15': 'IAB19-15 - Email',
  'IAB19-16': 'IAB19-16 - Graphics Software',
  'IAB19-17': 'IAB19-17 - Home Video/DVD',
  'IAB19-18': 'IAB19-18 - Internet Technology',
  'IAB19-19': 'IAB19-19 - Java',
  'IAB19-20': 'IAB19-20 - JavaScript',
  'IAB19-21': 'IAB19-21 - Mac Support',
  'IAB19-22': 'IAB19-22 - MP3/MIDI',
  'IAB19-23': 'IAB19-23 - Net Conferencing',
  'IAB19-24': 'IAB19-24 - Net for Beginners',
  'IAB19-25': 'IAB19-25 - Network Security',
  'IAB19-26': 'IAB19-26 - Palmtops/PDAs',
  'IAB19-27': 'IAB19-27 - PC Support',
  'IAB19-28': 'IAB19-28 - Portable',
  'IAB19-29': 'IAB19-29 - Entertainment',
  'IAB19-30': 'IAB19-30 - Shareware/Freeware',
  'IAB19-31': 'IAB19-31 - Unix',
  'IAB19-32': 'IAB19-32 - Visual Basic',
  'IAB19-33': 'IAB19-33 - Web Clip Art',
  'IAB19-34': 'IAB19-34 - Web Design/HTML',
  'IAB19-35': 'IAB19-35 - Web Search',
  'IAB19-36': 'IAB19-36 - Windows',

  IAB20: 'IAB20 - Travel',
  'IAB20-1': 'IAB20-1 - Adventure Travel',
  'IAB20-2': 'IAB20-2 - Africa',
  'IAB20-3': 'IAB20-3 - Air Travel',
  'IAB20-4': 'IAB20-4 - Australia & New Zealand',
  'IAB20-5': 'IAB20-5 - Bed & Breakfasts',
  'IAB20-6': 'IAB20-6 - Budget Travel',
  'IAB20-7': 'IAB20-7 - Business Travel',
  'IAB20-8': 'IAB20-8 - By US Locale',
  'IAB20-9': 'IAB20-9 - Camping',
  'IAB20-10': 'IAB20-10 - Canada',
  'IAB20-11': 'IAB20-11 - Caribbean',
  'IAB20-12': 'IAB20-12 - Cruises',
  'IAB20-13': 'IAB20-13 - Eastern Europe',
  'IAB20-14': 'IAB20-14 - Europe',
  'IAB20-15': 'IAB20-15 - France',
  'IAB20-16': 'IAB20-16 - Greece',
  'IAB20-17': 'IAB20-17 - Honeymoons/Getaways',
  'IAB20-18': 'IAB20-18 - Hotels',
  'IAB20-19': 'IAB20-19 - Italy',
  'IAB20-20': 'IAB20-20 - Japan',
  'IAB20-21': 'IAB20-21 - Mexico & Central America',
  'IAB20-22': 'IAB20-22 - National Parks',
  'IAB20-23': 'IAB20-23 - South America',
  'IAB20-24': 'IAB20-24 - Spas',
  'IAB20-25': 'IAB20-25 - Theme Parks',
  'IAB20-26': 'IAB20-26 - Traveling with Kids',
  'IAB20-27': 'IAB20-27 - United Kingdom',

  IAB21: 'IAB21 - Real Estate',
  'IAB21-1': 'IAB21-1 - Apartments',
  'IAB21-2': 'IAB21-2 - Architects',
  'IAB21-3': 'IAB21-3 - Buying/Selling Homes',

  IAB22: 'IAB22 - Shopping',
  'IAB22-1': 'IAB22-1 - Contests & Freebies',
  'IAB22-2': 'IAB22-2 - Couponing',
  'IAB22-3': 'IAB22-3 - Comparison',
  'IAB22-4': 'IAB22-4 - Engines',

  IAB23: 'IAB23 - Religion & Spirituality',
  'IAB23-1': 'IAB23-1 - Alternative Religions',
  'IAB23-2': 'IAB23-2 - Atheism/Agnosticism',
  'IAB23-3': 'IAB23-3 - Buddhism',
  'IAB23-4': 'IAB23-4 - Catholicism',
  'IAB23-5': 'IAB23-5 - Christianity',
  'IAB23-6': 'IAB23-6 - Hinduism',
  'IAB23-7': 'IAB23-7 - Islam',
  'IAB23-8': 'IAB23-8 - Judaism',
  'IAB23-9': 'IAB23-9 - Latter-Day Saints',
  'IAB23-10': 'IAB23-10 - Pagan/Wiccan',

  IAB24: 'IAB24 - Uncategorized',

  IAB25: 'IAB25 - Non-Standard Content',
  'IAB25-1': 'IAB25-1 - Unmoderated UGC',
  'IAB25-2': 'IAB25-2 - Extreme Graphic/Explicit Violence',
  'IAB25-3': 'IAB25-3 - Pornography',
  'IAB25-4': 'IAB25-4 - Profane Content',
  'IAB25-5': 'IAB25-5 - Hate Content',
  'IAB25-6': 'IAB25-6 - Under Construction',
  'IAB25-7': 'IAB25-7 - Incentivized',

  IAB26: 'IAB26 - Illegal Content',
  'IAB26-1': 'IAB26-1 - Illegal Content',
  'IAB26-2': 'IAB26-2 - Warez',
  'IAB26-3': 'IAB26-3 - Spyware/Malware',
  'IAB26-4': 'IAB26-4 - Copyright Infringement',
} as const
